import React  from 'react';
import Styled from 'styled-components';

export const LoaderWrapper = Styled.div`
  position: absolute;
  top: calc(50% - 75px);
  left: calc(50% - 75px);
  z-index: 2;
  display: ${props => props.show ? 'block' : 'none'}
`;



// WEBPACK FOOTER //
// ./src/ui/Loader/styles.js